/** Formatiert Cent als deutschen Euro-Betrag. */
export function euro(cents: number): string {
  return (cents / 100).toLocaleString("de-DE", { style: "currency", currency: "EUR" });
}
